import {getTempUnits, switchTempUnits} from "./temp_units_switch";
import {
    changeCalDirection,
    changeClockType,
    changeWeekStartDay,
    getCalDirection, getClockType,
    getWeekStartDay,
    initCalDirection
} from "./calendar_settings";
import {updateSubscriptionPrices} from "../util/localization";
import {updateExtraCalIcon} from "../calendar/holidays";
import {applyHoroscope, updateZodiacSign} from "../util/horoscope";
import {manager} from "../weather/weather_manager";
import {updateUVIndex} from "../weather/uvi/uvi";
import {setupNewFeatureIndicator} from "../util/version";
import {applyGoogleCalendar} from "../calendar/googleint/google_calendar";

const minutePrecipCheckBox = document.querySelector("#minute_precip_enabled_form input");
const precipCheckBox = document.querySelector("#precip_enabled_form input");
const uviCheckBox = document.querySelector("#uvi_enabled_form input");
const gCalCheckBox = document.querySelector("#gcal_sync_form input");
const tempCheckBox = document.querySelector("#temp_enabled_form input");
const windCheckBox = document.querySelector("#wind_enabled_form input");
const horoscopeCheckBox = document.querySelector("#horoscope_form input");

export let is_authenticated = false;


export function updateCheckboxSettingState(checkbox) {
    if (checkbox.checked) {
        manager.cards.forEach(card => card.enableSetting(checkbox.name));
    } else {
        manager.cards.forEach(card => card.disableSetting(checkbox.name));
    }
}

export function updateMinutePrecip() {
    if (minutePrecipCheckBox.checked) {
        manager.enableMinutelyWeather();
    } else {
        manager.disableMinutelyWeather();
    }
}

export function updatePrecip() {
    updateCheckboxSettingState(precipCheckBox);
}

export function updateTemp() {
    updateCheckboxSettingState(tempCheckBox);
}

export function updateWind() {
    updateCheckboxSettingState(windCheckBox);
}


function updateUserSettings(event) {
    let checkbox = event.target;

    // Store setting
    fetch('https://zima-backend.farawaytech.com/v1/user/settings', {
        method: 'PUT',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({[checkbox.name]: checkbox.checked})
    });
}

export function initializeSetting(inputName, retrieveStoredValue) {
    let radioInputs = document.querySelectorAll(`input[name='${inputName}']`);
    let storedValue = retrieveStoredValue();

    radioInputs.forEach(input => {
        let inputValue = input.getAttribute("data-value");
        input.checked = inputValue === storedValue;
    });
}

async function toggleCustomIcon(event) {
    try {
        // Create the payload to send in the request body
        const data = {
            holiday_key: event.target.getAttribute('name'),
            value: event.target.checked
        };

        // update settings
        await fetch('https://zima-backend.farawaytech.com/v1/user/custom_holidays', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        });
        // Handle the response data here
        await updateExtraCalIcon();
    } catch (error) {
        console.error('Failed to toggle custom icon:', error);
        // Handle the error here if necessary
    }
}


export function setupSettingsCommon() {
    initializeSetting('temperature_units', getTempUnits);
    initializeSetting('start_of_week', getWeekStartDay);
    initializeSetting('calendar_direction', getCalDirection);
    initializeSetting('clock_type', getClockType);
    initCalDirection();
    updateSubscriptionPrices();
    document.querySelectorAll("#extra_cal_icons input").forEach(s => s.addEventListener("change", event => toggleCustomIcon(event)));
    document.querySelectorAll(".settings input[name='temperature_units']").forEach(s => s.addEventListener("change", event => switchTempUnits(event)));
    document.querySelectorAll(".settings input[name='calendar_direction']").forEach(s => s.addEventListener("change", event => changeCalDirection(event)));
    document.querySelectorAll(".settings input[name='start_of_week']").forEach(s => s.addEventListener("change", event => changeWeekStartDay(event)));
    document.querySelectorAll("#settings_modal input[name='clock_type']").forEach(s => s.addEventListener("change", event => changeClockType(event)));
    document.querySelectorAll("#horoscope_signs input[name='zodiac_sign']").forEach(s => s.addEventListener("change", event => updateZodiacSign(event.target)));
}

function updateCredits(remaining, is_subscribed) {
    const creditsBar = document.getElementById('creditsBar');
    const creditsText = document.querySelectorAll('.credits-text');
    let availablePercent = Math.min(100*remaining/500, 99);

    creditsBar.style.width = `${availablePercent}%`;
    creditsText.forEach(e => {e.innerText = remaining});
    if (remaining <=5 && !is_subscribed) {
        document.getElementById("credits_container").classList.remove("hidden");
    }

    // Update color based on available space
    let colorClass = 'bg-green-500';
    if (availablePercent <= 25) {
        colorClass = 'bg-red-500';
    } else if (availablePercent <= 50) {
        colorClass = 'bg-orange-500';
    } else if (availablePercent <= 75) {
        colorClass = 'bg-yellow-500';
    }

    // Reset classes and apply new color
    creditsBar.className = 'h-2 rounded-l-full';
    creditsBar.classList.add(colorClass);
}


export function updateLoginState(auth_data) {
    let email = auth_data["email"];
    document.getElementById("user_email").textContent = email;
    let locInput = document.getElementById("autocompleteInput");
    let locForm = document.getElementById("autocompleteForm");

    if (email !== null) {
        is_authenticated = true;
        document.getElementById("signin_btn").parentElement.classList.add("hidden");
        document.getElementById("auth_menu").classList.remove("hidden");
        // update location input
        locInput.removeAttribute('disabled');
        locForm.classList.remove("disabled");
        if (auth_data["subscription"] === true) {
            document.getElementById("plans_btn").parentElement.classList.add("hidden");
            document.getElementById("unsubscribe_btn").parentElement.classList.remove("hidden");
            document.getElementById("settings__title__pro").classList.remove("hidden");
        } else {
            document.getElementById("plans_btn").parentElement.classList.remove("hidden");
            document.getElementById("unsubscribe_btn").parentElement.classList.add("hidden");
            document.getElementById("settings__title__pro").classList.add("hidden");
        }
        // update remaining credits
        updateCredits(auth_data["updates_remaining"], auth_data["subscription"]);
    } else {
        is_authenticated = false;

    }
    // set horoscope sign first -- checked property is set later and triggers update
    if (auth_data["zodiac_sign"]) {
        let z_sign = auth_data["zodiac_sign"];
        let cb = document.querySelector(`#horoscope_signs input[data-value="${z_sign}"]`);
        // TODO: remove after implementing horoscope on /app
        if (cb) {
            cb.checked = true;
        }
    }

    if (auth_data["settings"]) {
        for (const setting_name of ["precip", "minute_precip", "uvi", "solar_horoscope", "temp", "wind", "gcal_sync"]) {
            let checkbox = document.querySelector(`.settings input[name=${setting_name}]`);
            // some settings are not available on all platforms
            if (!checkbox) {
                continue;
            }
            checkbox.disabled = false;
            let form = checkbox.closest('form');
            if (form) {
                form.classList.remove("disabled");
            }
            if (auth_data["settings"][setting_name]["enabled"]) {
                if (checkbox.checked === false) {
                    checkbox.checked = true;
                }
            }
        }
    }
    if (auth_data["holiday_settings"]) {
        document.getElementById('extra_cal_icons').classList.remove("disabled");
        document.querySelectorAll("#extra_cal_icons input").forEach(checkbox => {
            let value = auth_data["holiday_settings"][checkbox.name]

            if (value === true) {
                checkbox.disabled = false;
                checkbox.checked = true;
            } else {
                checkbox.disabled = true;
                checkbox.checked = false;
            }
        });
    } else {
        document.getElementById('extra_cal_icons').classList.add("disabled");
        document.querySelectorAll("#extra_cal_icons input").forEach(e => {
            e.disabled = true;
        })
    }
}


document.getElementById("logout_btn").addEventListener("click", function () {
    fetch('https://zima-backend.farawaytech.com/v1/auth/logout', {
        method: 'POST',
        credentials: 'include',  // This is required for cookies to be included in cross-site requests
    }).then((response) => {
        if (!response.ok) {
            throw response;
        }
        window.location.href = '/';
    });
});


precipCheckBox.addEventListener('change', updateUserSettings);
minutePrecipCheckBox.addEventListener('change', updateUserSettings);
uviCheckBox.addEventListener('change', updateUserSettings);
horoscopeCheckBox.addEventListener('change', updateUserSettings);
tempCheckBox.addEventListener('change', updateUserSettings);
windCheckBox.addEventListener('change', updateUserSettings);
gCalCheckBox.addEventListener('change', updateUserSettings);


precipCheckBox.addEventListener('change', updatePrecip);
minutePrecipCheckBox.addEventListener('change', updateMinutePrecip);
tempCheckBox.addEventListener('change', updateTemp);
uviCheckBox.addEventListener('change', updateUVIndex);
windCheckBox.addEventListener('change', updateWind);
horoscopeCheckBox.addEventListener('change', applyHoroscope);
gCalCheckBox.addEventListener('change', applyGoogleCalendar);

// add new circle around settings if needed
setupNewFeatureIndicator();